// extracted by mini-css-extract-plugin
export var image = "product-how-it-works-module--image--abfff";
export var root = "product-how-it-works-module--root--8be14";